import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

/**
 * Activities Icon
 *
 * @file Activities.jsx
 * @author Kranthi Kiran Reddy Mattimadugu
 */

const Activities = (props) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <SvgIcon viewBox="0 0 18 18" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.803 2.47956L16.4939 6.39783C17.394 6.91567
        18 7.88706 18 9V15C18 16.6569 16.6569 18 15
        18H5C3.34315 18 2 16.6569 2 15V12.8435C1.53745
        12.4142 1.20599 11.8361 1.08797 11.1668L0.0460783
        5.25793C-0.241631 3.62625 0.847874 2.07027
        2.47956 1.78256L12.3276 0.0460783C13.9593 -0.241631
        15.5153 0.847874 15.803 2.47956ZM15 7.75H5C4.30964
        7.75 3.75 8.30964 3.75 9V15C3.75 15.6904 4.30964 16.25
        5 16.25H15C15.6904 16.25 16.25 15.6904 16.25 15V9C16.25
        8.30964 15.6904 7.75 15 7.75ZM11.475 12.6C11.7649 12.6 12
        12.9134 12 13.3C12 13.6866 11.7649 14 11.475
        14H6.525C6.23505 14 6 13.6866 6 13.3C6 12.9134 6.23505
        12.6 6.525 12.6H11.475ZM13.3 10C13.6866 10 14 10.3134
        14 10.7C14 11.0866 13.6866 11.4 13.3 11.4H6.7C6.3134
        11.4 6 11.0866 6 10.7C6 10.3134 6.3134 10 6.7 10H13.3ZM12.6315
        1.76949L2.78344 3.50597C2.10357 3.62585 1.64961 4.27418
        1.76949 4.95404L2.26515 7.76508C2.73589 6.72422 3.78337
        6 5 6H14.6468L14.0796 2.78344C13.9597 2.10357 13.3114
        1.64961 12.6315 1.76949Z"
      fill="currentcolor"
    />
  </SvgIcon>
);

export default Activities;
